/**
 * Main product form + sticky bar each render their own <variant-radios>.
 * Same radio `name` + same `form` made only one control "checked" globally — the other UI looked blank.
 * Sticky radios now use unique names and no form; this keeps both UIs aligned when either changes.
 */
(function () {
  function isStickyEl(el) {
    return !!(el && el.closest('.ts-sticky-addtocart, .mobile-variants-sticky'));
  }

  function radioForLabel(label) {
    var forId = label.getAttribute('for');
    if (forId) {
      var byId = document.getElementById(forId);
      if (byId) return byId;
    }
    return label.querySelector('input[type="radio"]');
  }

  var variantDataCache;
  function getVariantData() {
    if (variantDataCache) return variantDataCache;
    var json = document.querySelector('variant-radios [type="application/json"]');
    if (!json) return null;
    try {
      variantDataCache = JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
    return variantDataCache;
  }

  function updateAtcState(variantId) {
    var data = getVariantData();
    if (!data) return;
    var variant = data.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;
    var strings = window.variantStrings || {};
    var label = variant.available ? strings.addToCart : strings.soldOut;
    document.querySelectorAll('button.product-form__submit[name="add"]').forEach(function (btn) {
      if (variant.available) btn.removeAttribute('disabled');
      else btn.setAttribute('disabled', 'disabled');
      var span = btn.querySelector('.addcartbtn-ts');
      if (span && label) span.textContent = label;
    });
  }

  function normalizeImageToken(url) {
    if (!url) return '';
    var file = url.split('?')[0].split('/').pop() || '';
    return file.replace(/(_\d+x\d+.*)?\.(jpg|jpeg|png|gif|webp)$/i, '').toLowerCase();
  }

  function findGalleryMediaKey(sectionId, searchToken) {
    if (!searchToken) return null;
    var viewer = document.querySelector('[id^="GalleryViewer-' + sectionId + '"]');
    if (!viewer) return null;
    var slides = viewer.querySelectorAll('[data-media-id]');
    for (var i = 0; i < slides.length; i++) {
      var imgs = slides[i].querySelectorAll('img');
      for (var j = 0; j < imgs.length; j++) {
        var src = imgs[j].currentSrc || imgs[j].src || imgs[j].getAttribute('src') || '';
        var token = normalizeImageToken(src);
        if (token && (token === searchToken || src.indexOf(searchToken) !== -1)) {
          return slides[i].getAttribute('data-media-id');
        }
      }
    }
    return null;
  }

  function resolveGalleryMediaKey(variantId, sectionId) {
    var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(variantId) : String(variantId).replace(/"/g, '\\"');
    var label = document.querySelector('.product__info-container .cstmOptions[cstmvarint-id="' + esc + '"]');
    if (!label) return null;

    var mediaKey = label.getAttribute('data-gallery-media-id');
    if (mediaKey) return mediaKey;

    var imageSrc = label.getAttribute('data-variant-image-src');
    if (!imageSrc) {
      var thumb = label.querySelector('.cstmVariImg img');
      if (thumb) imageSrc = thumb.getAttribute('src') || thumb.src;
    }
    if (imageSrc) {
      mediaKey = findGalleryMediaKey(sectionId, normalizeImageToken(imageSrc));
      if (mediaKey) return mediaKey;
    }

    var data = getVariantData();
    if (!data) return null;
    var variant = data.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return null;

    if (variant.featured_media && variant.featured_media.id) {
      return sectionId + '-' + variant.featured_media.id;
    }
    if (variant.featured_image && variant.featured_image.src) {
      return findGalleryMediaKey(sectionId, normalizeImageToken(variant.featured_image.src));
    }
    return null;
  }

  function updateVariantMedia(variantId) {
    if (!variantId) return;
    var picker = document.querySelector('.product__info-container variant-radios');
    if (!picker || !picker.dataset.section) return;
    var sectionId = picker.dataset.section;
    var mediaKey = resolveGalleryMediaKey(variantId, sectionId);
    if (!mediaKey) return;

    document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]').forEach(function (gallery) {
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaKey, true);
      }
    });
  }

  function variantIdFromCheckedRadio() {
    var picker = document.querySelector('.product__info-container variant-radios');
    var checked = picker && picker.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var label = checked.closest('label.cstmOptions');
    if (!label && checked.id) {
      var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(checked.id) : checked.id;
      label = document.querySelector('label[for="' + esc + '"]');
    }
    return label && label.getAttribute('cstmvarint-id');
  }

  function syncVariantSelection(variantId) {
    if (!variantId) return;
    var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(variantId) : String(variantId).replace(/"/g, '\\"');
    var labels = document.querySelectorAll('.cstmOptions[cstmvarint-id="' + esc + '"]');
    if (!labels.length) return;

    document.querySelectorAll('.cstmOptions.selected').forEach(function (l) {
      l.classList.remove('selected');
    });
    labels.forEach(function (l) {
      l.classList.add('selected');
    });

    document.querySelectorAll('input.product-variant-id[name="id"]').forEach(function (input) {
      input.value = variantId;
      input.disabled = false;
    });

    var mainRadio = null;
    labels.forEach(function (l) {
      var radio = radioForLabel(l);
      if (!radio) return;
      radio.checked = true;
      if (!isStickyEl(l) && !mainRadio) mainRadio = radio;
    });

    if (mainRadio) {
      mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateAtcState(variantId);
    updateVariantMedia(variantId);
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;
    var picker = input.closest('variant-radios');
    if (!picker || picker.closest('.ts-sticky-addtocart, .mobile-variants-sticky')) return;
    if (!picker.closest('.product__info-container')) return;

    var label = input.closest('label.cstmOptions');
    if (!label && input.id) {
      var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(input.id) : input.id;
      label = document.querySelector('label[for="' + esc + '"]');
    }
    var variantId = label && label.getAttribute('cstmvarint-id');
    if (variantId) {
      window.setTimeout(function () {
        updateVariantMedia(variantId);
      }, 0);
    }
  });

  document.addEventListener('click', function (e) {
    var label = e.target.closest('.cstmOptions');
    if (!label) return;

    var variantId = label.getAttribute('cstmvarint-id');
    if (variantId) {
      syncVariantSelection(variantId);
      return;
    }

    var radio = radioForLabel(label);
    if (!radio) return;
    document.querySelectorAll('.cstmOptions.selected').forEach(function (l) {
      l.classList.remove('selected');
    });
    label.classList.add('selected');
    radio.checked = true;
    if (!isStickyEl(label)) {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  function getDefaultVariantId() {
    var info = document.querySelector('product-info[data-default-variant-id]');
    if (info) {
      var resolved = info.getAttribute('data-default-variant-id');
      if (resolved) return resolved;
    }
    var marked = document.querySelector('.product__info-container .cstmOptions[data-default-variant="true"]');
    if (marked) {
      var markedId = marked.getAttribute('cstmvarint-id');
      if (markedId) return markedId;
    }
    var checkedId = variantIdFromCheckedRadio();
    if (checkedId) return checkedId;
    var titleEl = document.querySelector('.product__info-container [data-selected]');
    return titleEl && titleEl.getAttribute('data-selected');
  }

  function initVariantSelection() {
    if (document.body.classList.contains('product-combo-current')) {
      document.querySelectorAll('.combo-variant-picker--merged').forEach(function (merged) {
        syncComboOption2(merged.closest('variant-radios'));
      });
    }
    var defaultId = getDefaultVariantId();
    if (!defaultId) {
      var first = document.querySelector('.product__info-container .cstmOptions[cstmvarint-id]');
      if (first) defaultId = first.getAttribute('cstmvarint-id');
    }
    if (defaultId) syncVariantSelection(defaultId);
  }

  function syncComboOption2(picker) {
    if (!picker) return;
    var checked = picker.querySelector('.combo-variant-picker--merged input:checked');
    var sync = picker.querySelector('.combo-variant-picker-sync');
    if (!checked || !sync) return;
    var match = [].find.call(sync.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value === checked.value;
    });
    if (match) match.checked = true;
  }

  document.addEventListener(
    'change',
    function (e) {
      if (e.target.type !== 'radio' || !e.target.closest('.combo-variant-picker--merged')) return;
      syncComboOption2(e.target.closest('variant-radios'));
    },
    true
  );

  function startVariantSelection() {
    var pickup = document.querySelector('pickup-availability');
    if (pickup && typeof pickup.fetchAvailability !== 'function') {
      customElements.whenDefined('pickup-availability').then(initVariantSelection);
      return;
    }
    initVariantSelection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startVariantSelection);
  } else {
    startVariantSelection();
  }
})();

(function () {
  function fieldsetsIn(vr) {
    return [...vr.children].filter(function (el) {
      return el.tagName === 'FIELDSET';
    });
  }

  function isStickyPicker(vr) {
    return !!(vr && vr.closest && vr.closest('.ts-sticky-addtocart, .mobile-variants-sticky'));
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.tagName !== 'INPUT' || input.type !== 'radio') return;

    var picker = input.closest('variant-radios');
    if (!picker || !picker.dataset.section) return;

    var sectionId = picker.dataset.section;
    var esc = typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(sectionId) : sectionId.replace(/"/g, '\\"');
    var peers = [].slice.call(document.querySelectorAll('variant-radios[data-section="' + esc + '"]'));
    if (peers.length < 2) return;

    var mainPicker = peers.find(function (p) {
      return !isStickyPicker(p);
    });
    var stickyPicker = peers.find(function (p) {
      return isStickyPicker(p);
    });
    if (!mainPicker || !stickyPicker) return;

    var mainFs = fieldsetsIn(mainPicker);
    var stickyFs = fieldsetsIn(stickyPicker);
    if (!mainFs.length || mainFs.length !== stickyFs.length) return;

    if (isStickyPicker(picker)) {
      var sIdx = stickyFs.findIndex(function (fs) {
        return fs.contains(input);
      });
      if (sIdx < 0) return;
      var mirror = [].find.call(mainFs[sIdx].querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === input.value;
      });
      if (mirror && mirror !== input) {
        mirror.checked = true;
        mirror.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      var mIdx = mainFs.findIndex(function (fs) {
        return fs.contains(input);
      });
      if (mIdx < 0) return;
      var twin = [].find.call(stickyFs[mIdx].querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === input.value;
      });
      if (twin && !twin.checked) twin.checked = true;
    }
  });
})();

(function () {
  if (window.__gmCardVariantSelectBound) return;
  window.__gmCardVariantSelectBound = true;

  var parseMoney = function (s) {
    return parseFloat(String(s || '').replace(/[₹,\s]/g, '')) || 0;
  };

  var variantPriceRupees = function (variant, formattedPrice) {
    var cents = parseInt(variant.getAttribute('data-price-cents'), 10);
    return cents > 0 ? cents / 100 : parseMoney(formattedPrice);
  };

  // Snapmint's pointerup on .size_swatch rebuilds the whole widget (slow). Block that on variant pills.
  document.addEventListener(
    'pointerup',
    function (e) {
      if (e.target.closest('.variant-select') && e.target.closest('.size_swatch')) {
        e.stopPropagation();
      }
    },
    true
  );

  var refreshSnapmintCard = function (card, priceRupees) {
    if (typeof getDownPaymentAndEmi !== 'function') return;
    var emiEl = card.querySelector('.dp-collection-price');
    if (!emiEl) return;

    var prodPrice = priceRupees;
    if (!prodPrice) {
      var priceEl = card.querySelector('.producrt_prices_bs .varintbjjgg');
      if (!priceEl) return;
      prodPrice = typeof parseNum === 'function' ? parseNum(priceEl.innerText) : parseMoney(priceEl.textContent);
    }
    if (!prodPrice) return;

    if (typeof snapOptions !== 'undefined' && snapOptions.plans && snapOptions.plans.length) {
      var min = typeof parseNum === 'function' ? parseNum(snapOptions.plans[0].minAmount) : 0;
      var max =
        typeof parseNum === 'function'
          ? parseNum(snapOptions.plans[snapOptions.plans.length - 1].maxAmount)
          : Infinity;
      if (prodPrice < min || prodPrice > max) return;
    }

    getDownPaymentAndEmi(prodPrice);
    if (typeof emi === 'undefined' || !emi) return;

    emiEl.textContent = String(typeof parseNum === 'function' ? parseNum(emi) : Math.round(emi));
    emiEl.setAttribute('data-price', String(Math.round(prodPrice)));
  };

  var setCardImage = function (img, url) {
    if (!img || !url) return;
    img.src = url;
    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.setAttribute('data-src', url);
    img.classList.add('lazyloaded');
    img.classList.remove('lazyloading');
    if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.unveil(img);
  };

  var cacheAtcContent = function (btn) {
    if (btn.dataset.atcContent) return;
    btn.dataset.atcContent = btn.querySelector('svg')
      ? btn.innerHTML.trim()
      : btn.textContent.trim() || 'Add to cart';
  };

  var setAtcState = function (btn, available) {
    cacheAtcContent(btn);
    if (available) {
      btn.removeAttribute('disabled');
      var content = btn.dataset.atcContent;
      if (content.indexOf('<') !== -1) btn.innerHTML = content;
      else btn.textContent = content;
    } else {
      btn.setAttribute('disabled', 'disabled');
      btn.textContent = 'Sold Out';
    }
  };

  document.addEventListener('click', function (e) {
    var variant = e.target.closest('.variant-select');
    if (!variant) return;

    variant.parentNode.querySelectorAll('.variant-select').forEach(function (el) {
      el.classList.remove('active');
    });
    variant.classList.add('active');

    var card = variant.closest('.card-wrapper');
    if (!card) return;

    var price = variant.getAttribute('data-prices');
    var compare = variant.getAttribute('data-prices-comp');
    var actual = variantPriceRupees(variant, price);
    var compareVal = parseMoney(compare);
    var pct = compareVal > actual ? Math.floor(((compareVal - actual) / compareVal) * 100) : 0;

    var atc = card.querySelector('.add_to_cart_' + variant.getAttribute('data-product-id'));
    if (atc) {
      atc.setAttribute('data-add-to-cart', variant.getAttribute('data-values'));
      if (variant.hasAttribute('data-available')) {
        setAtcState(atc, variant.getAttribute('data-available') === 'true');
      }
    }

    var priceEl = card.querySelector('.varintbjjgg');
    var compareEl = card.querySelector('.varintbjjggmmm');
    if (priceEl) priceEl.textContent = price;
    if (compareEl) compareEl.textContent = compare;
    refreshSnapmintCard(card, actual);

    var fdm = card.querySelector('.for-FDM');
    if (fdm) {
      var fdmBadge = fdm.querySelector('.price__badge-sale');
      if (pct > 0) {
        if (fdmBadge) fdmBadge.textContent = pct + '% OFF';
        fdm.classList.add('is-visible');
      } else {
        if (fdmBadge) fdmBadge.textContent = '';
        fdm.classList.remove('is-visible');
      }
    }

    card.querySelectorAll('.jkkjhkhkjhjk .price__badge-sale').forEach(function (el) {
      el.textContent = pct + '% OFF';
    });

    var badge = card.querySelector('.price__badge-sale');
    if (badge && !badge.closest('.for-FDM') && !badge.closest('.jkkjhkhkjhjk')) {
      badge.textContent = pct + '% OFF';
    }

    var img = card.querySelector('.meta-img, .change_on_varient_image');
    if (img) {
      setCardImage(
        img,
        variant.getAttribute('data-variant-image') ||
          img.getAttribute('data-default-src') ||
          img.getAttribute('data-src')
      );
    }
  });
})();

$(document).ready(function () {
  const $window = $(window);

  $('.filter-name-catelog-filter').on('click', function () {
    const href = this.getAttribute('href') || '';
    const targetId = href.includes('#') ? href.split('#')[1] : '';
    const $targetElement = targetId ? $('#' + targetId) : $();

    if ($targetElement.length) {
      let scrollOffset = $targetElement.offset().top;

      if ($window.width() <= 768) {
        scrollOffset -= 100;
      }

      $('html, body').animate({ scrollTop: scrollOffset }, 500);
    }

    $(this).addClass('active').siblings().removeClass('active');
  });
});

let cartEl = null;

async function updateCartDrawer() {
  // Cache the cart element
  if (!cartEl) {
    cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  if (!cartEl || typeof cartEl.renderContents !== 'function') return;

  const sections = (cartEl.getSectionsToRender?.().map((s) => s.id) || ['cart-drawer', 'cart-icon-bubble']).join(',');
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json());
    window.cartJsCache = cart;
    if (typeof window.gmApplyCartJsCache === 'function') window.gmApplyCartJsCache(cart);
    const res = await fetch(`/?sections=${sections}`, { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error(`Failed to load sections: ${res.status}`);
    const data = await res.json();
    cart.sections = data;

    const quickAddModal = document.querySelector('quick-add-modal');
    if (quickAddModal) {
      document.body.addEventListener(
        'modalClosed',
        () => cartEl.renderContents(cart),
        { once: true }
      );
      quickAddModal.hide(true);
    } else {
      cartEl.renderContents(cart);
    }

    const drawer = document.querySelector('.drawer');
    if (drawer) {
      drawer.classList.remove('is-empty');
      drawer.classList.add('active');
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'updateCartDrawer' } }));
  } catch (err) {
    console.error('Cart update error:', err);
    if (window.cartJsCache) cartEl.renderContents(window.cartJsCache);
  }
}
